import { mountComponent } from '../util/mount';
import { HtmlId } from 'app/enums/elementId';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { createButtonLink } from '@vfde-brix/ws10/button-link';

/**
 * Create Brix ButtonLink component.
 *
 * @param id - Wrapper ID of the element.
 * @param onClick - OnClick event.
 * @returns ButtonLink component or
 * null if the element with the given ID is not found.
 */
export const mountButtonLink = (id: HtmlId, onClick?: () => void) =>
    mountComponent(id, createButtonLink, onClick
        ? { onClick }
        : NO_PATTERN_BUSINESS_LOGIC,
    );
